import React, { useEffect } from 'react'

import Header from '../../../components/Turkey/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Turkey/PageTitle/PageTitle'
import Footer from '../../../components/Turkey/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import Subscribe from '../../../components/Turkey/Subscribe/Subscribe'
import Content from '../../../components/Content/Content'

export default function Wirerod() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={''} />
      <UnderHeader className={'wirerod'} />
      <PageTitle mainTitle={'FILMAŞIN'} page={'FILMAŞIN'} />
      <Content page={'wireRod'} />
      <Subscribe />
      <LogoPartner />
      <Footer />
    </div>
  )
}
